import { useLayoutEffect, useEffect, useState, useContext } from "react";
import { getChartDivisionsExp } from "../../../context/utils";
import { UiContext } from "../../../context/UiContext";
import { useTranslation } from "react-i18next";

export function MinuteGraphicImage({ heading, data }) {
  const { isMobile, hasShortHeightDetail} = useContext(UiContext);
  const { t } = useTranslation();

  useLayoutEffect(() => { }, []);

  useEffect(() => { }, []);

  const [widthPage, setWidthPage] = useState(window.innerWidth);
  function updateWidth() {
    setWidthPage(window.innerWidth);
  }

  window.addEventListener("resize", updateWidth);


  useEffect(() => {

  }, [widthPage]);

 if (!heading || !data || data.length === 0) {
    return <div>{t("network.loadingData")}</div>;
  }

  const parseData = (valueString) => {
    if (valueString === undefined) {
      return [0, 0];
    }
    valueString = valueString.indexOf('|') !== -1 ? valueString : valueString + '|0';
    let values = valueString.split('|');
    let parsedValues = values.map(value => parseFloat(values[0]));

    return ([
      isNaN(parsedValues[0]) ? 0 : parsedValues[0],
      isNaN(parsedValues[1]) ? 0 : parsedValues[1]
    ]);
  }
  //Hotfix para evitar erro quando troca de praça com menor numero de emissora ou seleciona praça sem emissoras selecionadas
  if (data != null && data[0].length - 4 > heading.enabled.length) {
    data = [];
  }
  let GridAudienceColumn = document.getElementsByClassName("divDate")[0];
  let pChartWidth = parseFloat(GridAudienceColumn != undefined ? getComputedStyle(GridAudienceColumn).width : '0') - 60;

  const chartTopPadding = 50;
  let pRowsHeaders = data.map(row => row.slice(0, 4));
  let pRowsColumns = data.length > 0 ? data[0].slice(4).map((_, i) => data.map(row => row[i + 4] === '0' ? '-' : row[i + 4])) : [];

  let maxValue = 0;
  let fullColumns = pRowsColumns.map((c, index) => {
    return c.map((cell, cellIndex) => {
      let value = parseData(cell)[0];
      maxValue = Math.max(maxValue, value);
      return value;
    })
  });

  let columns: any[][] = [];
  for (const col of fullColumns) {
    let newCol: any[] = [];
    let rowSum = 0;
    for (let j = col.length - 1; j >= 0; j -= 1) {
      let value = col[j];
      maxValue = Math.max(maxValue, value);
      newCol.push(value);
      rowSum += 1;
    }
    columns.push(newCol);
  }
  let pChartHeight = 264;
  let chartHeight = pChartHeight - chartTopPadding;
  let firstColumn = columns[0];
  let chartDivisions = getChartDivisionsExp(firstColumn, pChartWidth);

  let divisionElements = chartDivisions.map((x, index) => {
    if (index === chartDivisions.length - 1) {
      return null;
    }
    let headerIndex = (chartDivisions.length - 2 - index);
    let nextX = chartDivisions[index + 1];
    let type = pRowsHeaders[headerIndex] ? pRowsHeaders[headerIndex][0] : 0;
    let fillColor = '#444444';
    if (type === '1') fillColor = '#5A0000';
    if (type === '2') fillColor = '#003C5A';

    let fillOpacity = 0.4;
    let width = Math.max(0, nextX - x - 1);
    return width <= 0 ? null : (
      <rect
        key={index}
        x={x}
        y={0}
        width={width}
        height={pChartHeight}
        fill={fillColor}
        fillOpacity={fillOpacity}
      />
    );
  });


  return (
    <svg
      id="minuteGraphicImage"
      width={pChartWidth}
      height={pChartHeight}
      style={{
        bottom: 0,
        marginLeft: 30,
        backgroundColor: 'rgba(0, 0, 0, 0.6)',
        overflow: 'hidden',
        display: isMobile && hasShortHeightDetail ? 'none' : 'block',
      }}
    >
      {divisionElements}
      {columns.map((column, index) => {
        let backgroundColor = heading.enabled[index];
        let points = column.map((cell, cellIndex) => {
          let percentY = cell / maxValue;
          let x = chartDivisions[cellIndex];
          let y = chartTopPadding + chartHeight - percentY * chartHeight;
          y = (typeof y !== 'number') ? 0 : y;
          return `L${x}, ${y} `;
        });
        let strokeWidth = heading.selected === index ? 8 : 1;
        let linePath = 'M' + points.join(' ').substring(1);
        return (
          <path
            key={index}
            d={linePath}
            strokeWidth={strokeWidth}
            stroke={backgroundColor.color}
            fill='none'
          >
          </path>
        );
      })}
    </svg>
  );

}
